<section class="prf-section" [style.gap]="gap"><ng-content /></section>
